import type { Distance, Point } from "@pdfking/math"
import type { Sequence } from "@pdfking/tfunc"

import type { PathPoint } from "#public"

/** `points` joined by straight lines: each one's handles on itself. */
export const DrawPath = (points: Sequence<Point<Distance>>): PathPoint[] =>
  [...points].map(({ x, y }) => ({ x, y, before: { x, y }, after: { x, y } }))
